export enum Direction {
  Previous = -1,
  Next = 1,
}

/**
 * Given a generic list of items, and a current index, calculates and returns the index of the
 * following item, based on a skip algorithm, supplied by the shouldSkip function
 *
 * @param items  a list of items of any type
 * @param currentIndex current item index
 * @param shouldSkip a function stating the skip condition
 * @param direction step direction
 * @param stepSize step size
 */
function getFollowingIndex(items: any,
                           currentIndex: number,
                           shouldSkip: Function,
                           direction: Direction = Direction.Next,
                           stepSize: number = 1
): number {
  let nextIndex = calculateTargetIndex(items, currentIndex, direction, stepSize);
  let nextItem = items[nextIndex];
  while (shouldSkip(nextItem)) {
    currentIndex = nextIndex;
    nextIndex = calculateTargetIndex(items, currentIndex, direction, stepSize);
    nextItem = items[nextIndex];
  }
  return nextIndex;
}

/**
 * Given a generic list of items, and a current index, calculates and returns the index of the next
 * item based on the supplied parameters
 *
 * @param items a list of items of any type
 * @param currentIndex current item index
 * @param direction step direction
 * @param stepSize step size
 */
function calculateTargetIndex(items: [],
                              currentIndex: number,
                              direction: Direction = Direction.Next,
                              stepSize: number = 1
): number {
  return (currentIndex + (direction * (stepSize % items.length)) + items.length) % items.length;
}


export const navigationUtils = {
  getFollowingIndex,
  calculateTargetIndex
}
